import type { FunctionComponent } from "react";
import { Text } from "@smartsuite/react-ui/lib";

interface ActivityDetailsItemProps {
  label: string;
  children: React.ReactNode;
}

const style = { marginRight: 3 };
const wrapperStyle = { marginBottom: 10 };

export const ActivityDetailsItem: FunctionComponent<
  ActivityDetailsItemProps
> = ({ label, children }) => {
  return (
    <Text styles={wrapperStyle}>
      <span className="medium" style={style}>
        {label}:
      </span>
      {children}
    </Text>
  );
};
